import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppToolbarService} from '../../components/toolbar/services/app-toolbar.service';
import {CST_LIST_REFRESH_DISPOTITION, CST_TOOLBAR_BTN_EVENT} from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import {MatSort} from '@angular/material/sort';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';
import {ArmaRestDnList} from '../../classes/json-interface';
import {FilterType, IColumnFilter, TableFilter} from '../../components/arma-filter-item/ColumnFilter';
import {getJsonLocalStorage} from '../../classes/utilit';
import {MatPaginator} from '@angular/material/paginator';

const CST_STORAGE_VISIBILITY_COLUMN_LIST_DN = 'CST_STORAGE_VISIBILITY_COLUMN_LIST_DN';

interface ParamVisiblilityColumn {
  displayDnDate?: boolean;
  displayAnalysis?: boolean;
  displayExternalCode?: boolean;
  displayDesignation?: boolean;
  displayDrawing?: boolean;
  displayWeight?: boolean;
}

const CST_MAT_COLUMN_DOC_NO = 'DOC_NO';
const CST_MAT_COLUMN_DOC_DATE = 'DOC_DATE';
const CST_MAT_COLUMN_ORDER_CODE = 'MAT_COLUMN_ORDER_CODE';
const CST_MAT_COLUMN_ORDER_CODE_EXT = 'MAT_COLUMN_ORDER_CODE_EXT';
const CST_MAT_COLUMN_ORDER_DESIGNATION = 'MAT_COLUMN_ORDER_DESIGNATION';
const CST_MAT_COLUMN_ORDER_DRAWING = 'MAT_COLUMN_ORDER_DRAWING';
const CST_MAT_COLUMN_DOC_VALUE = 'DOC_VALUE';
const CST_MAT_COLUMN_DOC_ACTION = 'ACTION';


const CST_COLUMN_FILTER: IColumnFilter<ArmaRestDnList>[] = [
  { columnName: CST_MAT_COLUMN_DOC_DATE, filterType: FilterType.Datebox, matchedVariable: 'UnixBLDate' },
  { columnName: CST_MAT_COLUMN_ORDER_CODE_EXT, filterType: FilterType.Checkbox, matchedVariable: 'ArrayOrder',
    // @ts-ignore TODO: TS7053: Element implicitly has an 'any'
    isVariableArray: array => array['extAnalysisCode'] }
];

@Component({
  selector: 'app-list-dn',
  templateUrl: './list-dn.component.html',
  styleUrls: ['./list-dn.component.css']
})
export class ListDnComponent implements OnInit {

  readonly MAT_COLUMN_DOC_NO = CST_MAT_COLUMN_DOC_NO;
  readonly MAT_COLUMN_DOC_DATE = CST_MAT_COLUMN_DOC_DATE;
  readonly MAT_COLUMN_ORDER_CODE = CST_MAT_COLUMN_ORDER_CODE;
  readonly MAT_COLUMN_ORDER_CODE_EXT = CST_MAT_COLUMN_ORDER_CODE_EXT;
  readonly MAT_COLUMN_ORDER_DESIGNATION = CST_MAT_COLUMN_ORDER_DESIGNATION;
  readonly MAT_COLUMN_ORDER_DRAWING = CST_MAT_COLUMN_ORDER_DRAWING;
  readonly MAT_COLUMN_DOC_VALUE = CST_MAT_COLUMN_DOC_VALUE;
  readonly MAT_COLUMN_DOC_ACTION = CST_MAT_COLUMN_DOC_ACTION;

  readonly visibilityColumn: ParamVisiblilityColumn = getJsonLocalStorage(CST_STORAGE_VISIBILITY_COLUMN_LIST_DN, {
    displayAnalysis: true,
    displayDnDate: true,
    displayDrawing: true,
    displayWeight: true,
    displayDesignation: true,
    displayExternalCode: true
  });

  mHasExtCode: boolean = false;

  HTML_TABLE_HEADER_COL: string[] = [];
  HTML_TABLE_DATASOURCE: MatTableDataSource<ArmaRestDnList> = new MatTableDataSource<ArmaRestDnList>([]);

  inProgress: boolean = false;   // Si on load/refresh la liste es DN

  mTableFilter = new TableFilter(CST_COLUMN_FILTER);

  @ViewChild(MatSort, {static: true}) mMatSort!: MatSort;
  @ViewChild('TablePaginator', { static: true }) mTablePaginator!: MatPaginator;

  constructor(private mToolbar: AppToolbarService,
              private mArmaServMethod: ArmaServServerMethods) {
  }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Mes Bons de livraison';
    this.mToolbar.setDisposition(CST_LIST_REFRESH_DISPOTITION);
    this.mToolbar.getObservableClick(true).subscribe(next => this.onToolbarItemClick(next));
    this.mToolbar.getObservableSiteChange().subscribe(() => this.loadArrayDeliveryNote().catch(console.error));
    this.HTML_TABLE_DATASOURCE.filterPredicate = data => this.mTableFilter.match(data);
    this.HTML_TABLE_DATASOURCE.sort = this.mMatSort;
    this.HTML_TABLE_DATASOURCE.sortingDataAccessor = sortingDataAccessor;
    this.HTML_TABLE_DATASOURCE.paginator = this.mTablePaginator;
    this.updateArrayTableHeader(false);
    this.loadArrayDeliveryNote().catch(console.error);
  }

  private onToolbarItemClick(eventName: string) {
    switch (eventName) {
      case CST_TOOLBAR_BTN_EVENT.Refresh:
        this.loadArrayDeliveryNote().catch(console.error);
        break;
    }
  }

  async loadArrayDeliveryNote() {
    if (!this.inProgress) {
      this.inProgress = true;
      this.HTML_TABLE_DATASOURCE.data = [];
      try {
        //TODO: opti possible
        this.mHasExtCode = false;
        const arrayDn = await this.mArmaServMethod.getListDN(this.mToolbar.selectedSiteCode);
        arrayDn.forEach(dn => {
          dn.ArrayOrder.forEach(order => {
            if (order.extAnalysisCode)
              this.mHasExtCode = true;
          });
        });
        this.HTML_TABLE_DATASOURCE.data = arrayDn;
        this.updateArrayTableHeader(false);
        this.mTableFilter.generateColumnFiltersItemFromArray(CST_COLUMN_FILTER, this.HTML_TABLE_DATASOURCE.data);
        this.triggerFilter();
      } finally {
        this.inProgress = false;
      }
    }
  }

  updateArrayTableHeader(save: boolean) {
    this.HTML_TABLE_HEADER_COL.length = 0;
    this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_DOC_NO);
    if (this.visibilityColumn.displayDnDate)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_DOC_DATE);
    if (this.visibilityColumn.displayAnalysis)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_ORDER_CODE);
    if (this.mHasExtCode && this.visibilityColumn.displayExternalCode)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_ORDER_CODE_EXT);
    if (this.visibilityColumn.displayDesignation)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_ORDER_DESIGNATION);
    if (this.visibilityColumn.displayDrawing)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_ORDER_DRAWING);
    if (this.visibilityColumn.displayWeight)
      this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_DOC_VALUE);
    this.HTML_TABLE_HEADER_COL.push(this.MAT_COLUMN_DOC_ACTION);
    if (save)
      localStorage.setItem(CST_STORAGE_VISIBILITY_COLUMN_LIST_DN, JSON.stringify(this.visibilityColumn));
  }

  public triggerFilter() {
    this.HTML_TABLE_DATASOURCE.filter = Date.now().toString();
  }

  getDN(element: ArmaRestDnList, download: boolean) {
    this.mArmaServMethod.downloadDN(element.DOC_NO, download).catch(console.error);
  }

  downloadAll() {
    this.mArmaServMethod.downloadAllDn().catch(console.error);
  }

  get HTML_CURRENT_SITE(): string {
    return this.mToolbar.selectedSiteCode;
  }

  asDnList(value: ArmaRestDnList): ArmaRestDnList {
    return value;
  }

}

const sortingDataAccessor = (item: ArmaRestDnList, property: string): string|number => {
  switch (property) {
    case CST_MAT_COLUMN_DOC_DATE:
      return item.UnixBLDate;
    case CST_MAT_COLUMN_DOC_VALUE:
      return +(item.DOC_VALUE).replace(/\s+/g, '');
    default:
      // @ts-ignore TODO: TS7053: Element implicitly has an 'any'
      return item[property];
  }
};
